import * as React from 'react';
import {Program} from "./Visitors/Program";
import {Map} from '../components/Map';
import {GalleryConference} from "./Main/GalleryConference";
import {Brands} from "../components/Brands";

declare const require: any;
const $: any = require('jquery');

export class Paid extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            id: this.props.params['id'],
            paid: false,
            price: null,
            status: false
        };
    }
    
    componentDidMount() {
        this.updateData();
    }
    
    private updateData() {
        $.get('/reg/get', {id: this.state.id}, (data) => {
            if (data.hasOwnProperty('error')) {
                alert(data.error);
            } else {
                this.setState({status: true, id: data._id, price: data.price, paid: data.paid});
            }
        }, 'json').error(function () {
            alert('Что-то пошло не так. Попробуйте еще раз.');
        });
    }
    
    render() {
        if (this.state.status) {
            return (
                <div className="visitors">
                    <h1>Оплата выполнена</h1>
                    <div className="note">
                        <a className="btn" href={"/ticket.html?" + this.state.id} target="_blank">Распечатайте ваш билет {this.state.number}</a>
                    </div>
                    <Program />
                    <div className="run-a-game">
                        <div className="bn">
                            Не пропусти розыгрыш подарков
                            по номеру пригласительного билета!
                        </div>
                    </div>
                    <Brands />
                    <GalleryConference />
                    <div className="row">
                        <Map />
                    </div>
                </div>
            )
        } else {
            return (
                <div className="visitors">
                    <h1>Загружается информация об оплате, подождите...</h1>
                </div>
            )
        }
    }
}



/** WEBPACK FOOTER **
 ** ./src/route/Paid.tsx
 **/